import { useEffect, useMemo } from 'react';
import { StyledSelect } from '~/components/dropdowns/select.style';
import { OnChangeMeta } from '~/components/validating-input';

interface LmiQualifyingProgramSelectComponentProps {
  onChange: (value: string, meta: OnChangeMeta) => void;
  value: number | string;
  label?: string;
  optional?: boolean;
  options?: { text: string; value: string; disabled: boolean; selected: boolean }[];
}
export const LmiQualifyingProgramSelectComponent = ({
  onChange,
  value,
  optional,
  label,
  options,
}: LmiQualifyingProgramSelectComponentProps) => {
  const lmiProgramOptions = useMemo(() => {
    const assistancePrograms = {
      liheap: 'Low Income Home Energy Assistance Program (LIHEAP)',
      usf: 'Universal Service Fund (USF)',
      comfortPartners: 'Comfort Partners',
      lifelineUtilityAssistanceProgram: 'Lifeline utility assistance program',
      page: 'Payment Assistance for Gas and Electric (PAGE)',
      section8HousingChoiceVoucherProgram: 'Section 8 Housing Choice Voucher Program',
      snap: 'Supplemental Nutrition Assistance Program (SNAP)',
      lifelineProgram: 'Lifeline program (Universal Service Administrative Company)',
      medicaid: 'Medicaid',
      ssiOrSsdi:
        'Supplemental Security Income (SSI) or Social Security Disability Insurance (SSDI)',
      wic: 'Special Supplemental Nutrition Program for Women, Infants, and Children (WIC)',
      tanf: 'Temporary Assistance for Needy Families (TANF)',
      lihwap: 'Low-Income Household Water Assistance Program (LIHWAP)',
    };
    return Object.keys(assistancePrograms).map(programKey => {
      return {
        disabled: false,
        selected: false,
        text: assistancePrograms[programKey],
        value: programKey,
      };
    });
  }, []);

  useEffect(() => {
    if (optional) {
      onChange('', { isValid: true, name: 'lmiProgram' });
    }
  }, [optional]);

  const handleChange = (program: string) => {
    onChange(lmiProgramOptions.find(option => option.value === program)?.text, {
      isValid: true,
      name: 'lmiProgram',
    });
  };

  return (
    <StyledSelect
      marginBottom="20px"
      marginTop="20px"
      disabled={false}
      id="qualifying-program-select"
      label={label || 'Select your LMI qualifying program (if applicable)'}
      withEmptyPlaceholder
      loading={false}
      minHeight="auto"
      name="lmiProgram"
      onChange={handleChange}
      options={options || lmiProgramOptions}
      value={lmiProgramOptions.find(option => option.value === value)?.value}
    />
  );
};
